import { Catalog, CatalogProductLatestOperation } from "src/api-service";
import { AppError } from "../../app-store-error.types";

// **************************************************************************
// CATALOG UI SETTINGS
// **************************************************************************

export type CatalogLayout = "list" | "grid";
export type CatalogDensity = "compact" | "normal" | "comfortable";

// **************************************************************************
// CATALOG STATE
// **************************************************************************
export interface CatalogState {
    catalog: Catalog | null;
    catalogs: Catalog[];
    latestOperation: CatalogProductLatestOperation | null;
    selectedFinancingCompanyId: number | null;
    financingCompanyName: string | null;
    // List UI state
    loaded: boolean;
    // UI settings
    catalogLayout: CatalogLayout;
    catalogDensity: CatalogDensity;
    // Loading
    loadingList: boolean;
    loadingDetail: boolean;
    updatingDetail: boolean;
    loadingBuilder: boolean;
    lockingPrices: boolean;
    // Error
    error: AppError | null;
}

export const initialCatalogState: CatalogState = {
    catalog: null,
    catalogs: [],
    latestOperation: null,
    selectedFinancingCompanyId: null,
    financingCompanyName: null,
    // List UI state
    loaded: false,
    // UI settings
    catalogLayout: "grid",
    catalogDensity: "normal",
    // Loading
    loadingList: false,
    loadingDetail: false,
    updatingDetail: false,
    loadingBuilder: false,
    lockingPrices: false,
    // Error
    error: null,
};
